import { iDCardTypesLabel, formatOldCatType, isForeign } from '@/views/commonConfig/investorConfig';

const mixin = {
  data() {
    return {
      Model: {
        userName: null,
        userSex: null,
        userAge: null,
        catType: '身份证',
        idCardNo: null,
        userCountry: '中国',
        userOccupation: null,
        userPosition: null,
        userLandline: null,
        userMobile: null,
        zip: null,
        userEmail: null,
        userAddress: '',
        documentsValidity: null,
      },
      options: {
        scrollToInvalidField: false,
        layout: 'standard',
      },
      fields: [
        {
          type: 'input',
          modelKey: 'userName',
          label: '姓名',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'catType',
          label: '证件类型',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'idCardNo',
          label: '证件号码',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'documentsValidity',
          label: '证件有效期',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'userSex',
          label: '性别',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'userAge',
          label: '年龄',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'userCountry',
          label: '国籍',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'userOccupation',
          label: '职业',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'userPosition',
          label: '职务',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'userEmail',
          label: '电子邮箱',
          props: {
            type: 'tel',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'userLandline',
          label: '座机',
          props: {
            type: 'tel',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'userMobile',
          label: '手机',
          props: {
            type: 'number',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'zip',
          label: '邮编',
          props: {
            type: 'number',
            disabled: true,
          },
        },
        {
          type: 'textarea',
          modelKey: 'userAddress',
          label: '住址',
          props: {
            disabled: true,
            placeholder: '',
          },
        },
      ],
      Schema: {
        groups: [
          {
            legend: '基本信息',
            fields: [
              {
                type: 'input',
                modelKey: 'userName',
                label: '姓名',
                props: {
                  type: 'text',
                  disabled: true,
                },
              },
              {
                type: 'input',
                modelKey: 'catType',
                label: '证件类型',
                props: {
                  disabled: true,
                  type: 'text',
                },
              },
              {
                type: 'input',
                modelKey: 'idCardNo',
                label: '证件号码',
                props: {
                  type: 'text',
                  disabled: true,
                },
              },
              {
                type: 'input',
                modelKey: 'documentsValidity',
                label: '证件有效期',
                props: {
                  type: 'text',
                  disabled: true,
                },
              },
            ],
          },
          {
            legend: '',
            fields: [
              {
                type: 'input',
                modelKey: 'userSex',
                label: '性别',
                props: {
                  disabled: true,
                  type: 'text',
                },
              },
              {
                type: 'input',
                modelKey: 'userAge',
                label: '年龄',
                props: {
                  disabled: true,
                  type: 'text',
                },
              },
              {
                type: 'input',
                modelKey: 'userCountry',
                label: '国籍',
                props: {
                  disabled: true,
                  type: 'text',
                },
              },
            ],
          },
          {
            legend: '',
            fields: [
              {
                type: 'input',
                modelKey: 'userOccupation',
                label: '职业',
                props: {
                  disabled: true,
                  type: 'text',
                },
              },
              {
                type: 'input',
                modelKey: 'userPosition',
                label: '职务',
                props: {
                  type: 'text',
                  disabled: true,
                },
              },
              {
                type: 'input',
                modelKey: 'userEmail',
                label: '电子邮箱',
                props: {
                  type: 'tel',
                  disabled: true,
                },
              },
              {
                type: 'input',
                modelKey: 'userLandline',
                label: '座机',
                props: {
                  type: 'tel',
                  disabled: true,
                },
              },
              {
                type: 'input',
                modelKey: 'userMobile',
                label: '手机',
                props: {
                  type: 'number',
                  disabled: true,
                },
              },
            ],
          },
          {
            legend: '',
            fields: [
              {
                type: 'input',
                modelKey: 'zip',
                label: '邮编',
                props: {
                  type: 'number',
                  disabled: true,
                },
              },
              {
                type: 'textarea',
                modelKey: 'userAddress',
                label: '住址',
                props: {
                  disabled: true,
                  placeholder: '',
                },
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    // 获取证件类型名称
    $_iDCardTypesLabel: iDCardTypesLabel,
    // 老数据处理
    $_formatOldCatType: formatOldCatType,
    // 判断是否显示国籍
    $_isForeign: isForeign,
  },
};
export default mixin;
